import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { toast } from 'src/app/model/toast';
import { MediaService } from 'src/app/service/media.service';
import { CampagneAndOfferFctService } from 'src/app/service/campagne-and-offer-fct.service';
import { finalize } from 'rxjs/operators';

export interface PigePicJson {
  date: Date;
  content: PigePost[];
}

export interface PigePost {
  date: Date;
  picture: string;
  caption: string;
}

@Component({
  selector: 'app-pige-admin',
  templateUrl: './pige-admin.component.html',
  styleUrls: [
    './pige-admin.component.css', 
    '../../../assets/styles/table.css', 
    '../../../assets/styles/panel.css',
    '../../../assets/styles/text-title.css',
    '../../../assets/styles/button.css',
    '../../../assets/styles/body.css',
    '../../../assets/styles/dashboard.css', 
    '../../../assets/styles/campagne.css'
  ],
  providers: [MediaService]
})
export class PigeAdminComponent implements OnInit {
  pigeExtern: FormGroup;
  exportArrayFiles: string[] = [];
  toast = toast;
  loading = false;
  isUploading = false;
  keywords: string[] = [];
  keywordsInput = '';
  accountsInput = '';
  accounts: string[] = [];
  exportFile = false;
  exportFileUP = false;
  picPige: PigePicJson = {
    date: new Date(),
    content: [],
  };

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    public picService: MediaService,
    private toastr: ToastrService,
    public fctBasic: CampagneAndOfferFctService,
    private cdRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.pigeExtern = this.fb.group({
      slideName: new FormControl(''),
    });
  }

  checkSpaceOnString(str: string, array: string[]): void {
    const tmpstr = str.split(' ');
    tmpstr.forEach((elem) => {
      if (elem && elem !== ' ') {
        const verif = this.verifiedIndexOf(elem, array);
        if (!verif) {
          array.push(elem);
        }
      }
    });
  }

  addElement(value: string): void {
    switch (value) {
      case 'keywords':
        this.checkSpaceOnString(this.keywordsInput, this.keywords);
        this.keywordsInput = '';
        break;
      case 'accounts':
        this.checkSpaceOnString(this.accountsInput, this.accounts);
        this.accountsInput = '';
        break;
    }
  }

  deleteElement(index: number, value: string): void {
    switch (value) {
      case 'keywords':
        this.keywords.splice(index, 1);
        break;
      case 'accounts':
        this.accounts.splice(index, 1);
        break;
    }
  }

  verifiedIndexOf(elem: string, array: string[]): boolean {
    return array.some(item => item === elem);
  }

  async modifPicture(event: any): Promise<boolean> {
    if (!event.target.files || event.target.files.length === 0) {
      return false;
    }
    
    this.isUploading = true;
    this.cdRef.detectChanges();
    
    try {
      await Promise.all([...event.target.files].map((file: any) => {
        return new Promise<void>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const extension = this.picService.getExtentionImg(file);
            if (extension !== false) {
              const fd = new FormData();
              fd.append('file', file, file.name);
              this.apiService.postPicture(fd)
                .pipe(finalize(() => resolve()))
                .subscribe(
                  path => {
                    this.picPige.content.push({
                      picture: path[0], 
                      caption: '', 
                      date: new Date()
                    });
                    this.cdRef.detectChanges();
                  },
                  error => {
                    this.toastr.error('Failed to upload image');
                    console.error('Upload error:', error);
                  }
                );
            } else {
              this.toastr.error('Invalid file format');
              resolve();
            }
          };
          reader.readAsDataURL(file);
        });
      }));
    } finally {
      this.isUploading = false;
      this.cdRef.detectChanges();
    }
    
    return false;
  }

  deleteImgForModif(img: string, elem: PigePost): void {
    if (!img) {
      const index = this.picPige.content.indexOf(elem);
      if (index > -1) {
        this.picPige.content.splice(index, 1);
        this.cdRef.detectChanges();
      }
      return;
    }
    
    this.apiService.deletePicture(img).subscribe({
      next: () => {
        this.toastr.success('Image deleted successfully');
        const index = this.picPige.content.indexOf(elem);
        if (index > -1) {
          this.picPige.content.splice(index, 1);
        }
        this.cdRef.detectChanges();
      },
      error: (err) => {
        console.error('Delete error:', err);
        this.toastr.error('Failed to delete image');
      }
    });
  }

  generateExpress(): void {
    if (this.picPige.content.length === 0) {
      this.toastr.warning('Please add at least one image');
      return;
    }
    
    this.loading = true;
    this.cdRef.detectChanges();
    this.apiService.exportFilePigeExternExpress(this.picPige, this.pigeExtern.value.slideName)
      .pipe(finalize(() => {
        this.loading = false;
        this.cdRef.detectChanges();
      }))
      .subscribe({
        next: (res) => {
          if (res.url === '400') {
            this.toastr.error(this.toast.campaignCreate || 'Error creating presentation');
            return;
          }
          
          this.exportFile = true;
          this.exportFileUP = true;
          const urlPige = '/api/export/pptx/' + res.url;
          this.exportArrayFiles.push(urlPige);
          this.toastr.success('Presentation created successfully');
        },
        error: (err) => {
          console.error('Generate error:', err);
          this.toastr.error('Failed to generate presentation');
        }
      });
  }

 
}